import type { DoctorShift } from '../../types/doctorShift';
import type {
  DoctorShiftRepository,
  FetchDoctorShiftsParams,
} from './ports/DoctorShiftRepository';

/**
 * ユースケース結果
 */
export interface FetchDoctorShiftsResult {
  success: boolean;
  shifts: DoctorShift[];
  error?: string;
}

/**
 * 医師シフト一覧取得ユースケース
 *
 * @description
 * 指定された期間の医師シフト一覧を取得する。
 * フィルタリング条件（医師ID、時間帯）による絞り込みをサポート。
 *
 * @param {DoctorShiftRepository} repository - リポジトリ実装
 * @param {FetchDoctorShiftsParams} params - 取得パラメータ
 * @returns {Promise<FetchDoctorShiftsResult>} 取得結果
 *
 * @example
 * const result = await fetchDoctorShiftsUseCase(repository, {
 *   startDate: '2025-01-01',
 *   endDate: '2025-01-31'
 * });
 */
export const fetchDoctorShiftsUseCase = async (
  repository: DoctorShiftRepository,
  params: FetchDoctorShiftsParams
): Promise<FetchDoctorShiftsResult> => {
  try {
    const shifts = await repository.fetchShifts(params);
    return {
      success: true,
      shifts,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'シフトデータの取得に失敗しました';
    return {
      success: false,
      shifts: [],
      error: errorMessage,
    };
  }
};
